import Vue from 'vue';
import Vuex from 'vuex';

import scans from './modules/scans';
import partnerships from './modules/partnerships';
import users from './modules/users';
import application from './modules/application';
import notes from './modules/notes';
import nav from './modules/nav';
import entity from './modules/entity';
import funding from './modules/funding';
import documents from './modules/documents';
import leaders from './modules/leaders';
import trends from './modules/trends';
import benchmarks from './modules/benchmarks';
import stash from './modules/stash';
import basicAuth from './modules/basicAuth';
import oidcAuth from './modules/oidcAuth';
import auth from './modules/auth';
import help from './modules/help';
import bulkExport from './modules/bulkExport';
import messageBroker from "./modules/messageBroker";
import collaboration from "./modules/collaboration";
import blueLens from "./modules/blueLens";
import filters from './modules/filters';
import workspaces from './modules/workspaces';

Vue.use(Vuex);

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default function (/* { ssrContext } */) {
  const Store = new Vuex.Store({
    modules: {
      auth,
      basicAuth,
      oidcAuth,
      users,
      scans,
      partnerships,
      app: application,
      notes,
      nav,
      entity,
      funding,
      documents,
      leaders,
      trends,
      benchmarks,
      stash,
      help,
      bulkExport,
      io: messageBroker,
      collab: collaboration,
      blueLens,
      filters,
      workspaces,
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: false,
  });

  return Store;
}
